import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/auth';

const Navbar = ({ auth: { isAuthenticated }, logout }) => {
  const authLinks = (
    <ul>
      {/* <li>
        <Link to="/profiles">Developers</Link>
      </li> */}
      {/* <li>
        <Link to="/posts">Posts</Link>
      </li> */}
      <li>
        <Link to="/">
          <i className="fas fa-user" />{' '}
          <span className="hide-sm">Home</span>
        </Link>
      </li>
      <li>
        <a onClick={logout} href="#!">
          <i className="fas fa-sign-out-alt" />{' '}
          <span className="hide-sm">Logout</span>
        </a>
      </li>
    </ul>
  );

  const guestLinks = (
    <ul className="flex">
      <li>
        {/* <Link to="/register" className="text-white ">Register</Link> */}
      </li>
      <li>
        <Link to="/login" className="text-white">Login</Link>
      </li>
    </ul>
  );

  return (
    <nav className="navbar bg-dark">
        <h1><Link to="/" className="text-white">JAMDAO</Link></h1>
        <Fragment>{isAuthenticated ? authLinks : guestLinks}</Fragment>
    </nav>
  );
};

Navbar.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, { logout })(Navbar);
